import { getAksApiUrl, getBlenderServiceUrl, getGaraUrl, getPortalUrl } from "../selectors";

export function initializeApiSettings() {
  localStorage.setItem('aks_api_base_url', getAksApiUrl());
  localStorage.setItem('blender_url', getBlenderServiceUrl());
  localStorage.setItem('gara_url', getGaraUrl());
  localStorage.setItem('portal_url', getPortalUrl());
}